export enum JobPriorities {
  No_Priority = 0,
  One_Star = 1,
  Two_Stars = 2,
  Three_Stars = 3,
}
